import { Component, HostListener, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { DocumentAIService } from '../../services/documentAI.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-shared-automation-panel',
  templateUrl: './shared-automation-panel.component.html',
  styleUrl: './shared-automation-panel.component.scss'
})
export class SharedAutomationPanelComponent implements OnInit, OnChanges {
  @Input() caseId: any;
  @Input() caseRecordTypeId: any;
  @Input() getCaseRecordTypeIdFilter: any;
  @Input() caseStatus: string;
  containerHeight: number
  Jobs: any = [];
  automationDataList: any[] = [];
  constructor(
    public authService: AuthService, private service: DocumentAIService,
    private route: ActivatedRoute,
    public toaster: ToastrService,
  ) {

  }

  ngOnInit(): void {
        this.loadAutomationlist();

  this.getJobIdFromCaseTypes();
      this.setContainerHeight()
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reload automation list when caseStatus changes
    if (changes['caseStatus'] && !changes['caseStatus'].firstChange) {
      this.loadAutomationlist();
    }
    // Also reload if caseId or getCaseRecordTypeIdFilter changes
    if ((changes['caseId'] || changes['getCaseRecordTypeIdFilter']) && 
        !changes['caseId']?.firstChange && !changes['getCaseRecordTypeIdFilter']?.firstChange) {
      this.loadAutomationlist();
    }
  }
  
  getJobIdFromCaseTypes() {
    this.service.getJobsHistory(this.caseId).subscribe((result: any) => {
      const filteredResult = result.filter((job: { jobName: string }) => job.jobName !== 'apifailed');
      this.Jobs = this.transformJobsForCardView(filteredResult);
    });
  }

  transformJobsForCardView(jobs: any[]): any[] {
    return jobs.map((job: any) => {
      const checkpointList = job.checkpointList || [];
      let startTime = null;
      let endTime = null;

      if (checkpointList.length > 0) {
        // First checkpoint is usually the start
        startTime = checkpointList[0]?.createdOn;
        // Last checkpoint is usually the end
        endTime = checkpointList[checkpointList.length - 1]?.createdOn;
      }

      return {
        ...job,
        startTime: startTime,
        endTime: endTime,
        displayStartTime: startTime ? this.formatDateTime(startTime) : 'N/A',
        displayEndTime: endTime ? this.formatDateTime(endTime) : 'N/A'
      };
    });
  }

  formatDateTime(dateString: string): string {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (e) {
      return 'N/A';
    }
  }

  getStatusClass(status: string): string {
    if (!status) return 'status-default';
    const statusLower = status.toLowerCase();
    if (statusLower.includes('completed') || statusLower.includes('success')) {
      return 'status-success';
    } else if (statusLower.includes('error') || statusLower.includes('failed')) {
      return 'status-error';
    } else if (statusLower.includes('pending') || statusLower.includes('requested')) {
      return 'status-pending';
    } else if (statusLower.includes('progress') || statusLower.includes('running')) {
      return 'status-progress';
    }
    return 'status-default';
  }

  refreshAutomationList() {
    this.loadAutomationlist();
    this.getJobIdFromCaseTypes();
  }

  loadAutomationlist() {
    if (this.getCaseRecordTypeIdFilter === null || this.getCaseRecordTypeIdFilter === '') {
      let getCaseRecordTypeIdFilters = this.getCaseRecordTypeId()
      this.getCaseRecordTypeIdFilter = getCaseRecordTypeIdFilters
    }
    let queryString = `?caseTypeId=${this.getCaseRecordTypeIdFilter}`;
    if (this.caseStatus && this.caseStatus !== 'undefined' && this.caseStatus.trim() !== '') {
      queryString += `&caseStatus=${this.caseStatus}`;
    }
    console.log('Loading automation list with query:', queryString);
    this.service
      .getCaseRecordTypeAutomationById(queryString)
      .subscribe(
        (data: any) => {
          this.automationDataList = [];
          for (const item of data.result) {
            this.automationDataList.push(item)
          }

        });
  }
  private getCaseRecordTypeId() {
    return localStorage.getItem('CaseRecordTypeIdFilter');
  }
  getAutomation(automationData: any) {
    this.service
      .runNowAutomation(automationData.id, this.caseId, null)
      .subscribe(
        (data: any) => {
          this.toaster.success("Automation enqueued for execution");
          // Wait 5 seconds before refreshing the automation list
          setTimeout(() => {
            this.getJobIdFromCaseTypes();
          }, 5000);
        });
  }
    setContainerHeight() {
      this.containerHeight = window.innerHeight - 200
      const layoutWrapperElement = document.querySelector('.layout-wrapper')
      if (layoutWrapperElement) {
          // layoutWrapperElement.classList.add('layout-static-inactive');
      }
    }
    @HostListener('window:resize', ['$event'])
        onResize(event: Event) {
            this.setContainerHeight()
        }
}
